<ion-segment
  class="xs:grid md:block xl:grid"
  [ngClass]="additionalClasses"
  [value]="settingOption"
  (ionChange)="onSegmentChange($event)"
>
  <ion-segment-button class="custom-segment-button" value="ringColor">
    <ion-label>Anillas</ion-label>
  </ion-segment-button>
  <ion-segment-button
    *ngIf="isLaminatedCover || isBindingLaminated"
    class="custom-segment-button"
    value="laminationOptions"
  >
    <ion-label>{{ !isBindingLaminated ? 'Portada' : 'Opción plastificado' }}</ion-label>
  </ion-segment-button>
  <ion-segment-button
    *ngIf="!isLaminatedCover && !isBindingLaminated && !isA3"
    class="custom-segment-button"
    value="hardCoverFront"
  >
    <ion-label>Tapa<br />Delantera</ion-label>
  </ion-segment-button>
  <ion-segment-button *ngIf="!isBindingLaminated && !isA3" class="custom-segment-button" value="hardCoverBack">
    <ion-label>Tapa<br />Trasera</ion-label>
  </ion-segment-button>
</ion-segment>

<!-- OPCIONES ENCUADERNADOS -->
<div *ngIf="settingOption !== 'laminationOptions'" [ngClass]="additionalClasses" class="laminations">
  <!-- TITULO DEL PRODUCTO ELEGIDO -->
  <ion-row class="ion-justify-content-center mb-15 mt-5">
    <div class="segment-selection">
      Color escogido:
      {{ utils.getColorName(settings[settingOption].options[settings[settingOption].selected - 1]?.value.name) || '' }}
    </div>
  </ion-row>

  <!-- BUCLE FOR DE LAS ANILLAS O TAPAS  -->
  <div class="flex flex-row flex-wrap items-center justify-start gap-1.5">
    <!-- Opciones sin categoría -->
    <div
      #tooltip1="tooltip"
      class="selection"
      *ngFor="let option of groupedOptions.noCategory; let i = index"
      [tooltip]="
        utils.getColorName(option.value.name) +
        (isSoldOut(option, settings[settingOption].selected === i + 1) ? ' (No disponible)' : '')
      "
      [tooltipClass]="isSoldOut(option, settings[settingOption].selected === i + 1) ? 'red-tooltip' : ''"
      [ngClass]="{ selected: settings[settingOption].selected === i + 1 }"
    >
      <div
        (click)="onSelectOption(i, isSoldOut(option, settings[settingOption].selected === i + 1))"
        class="image-container zoom"
      >
        <img
          *ngIf="getOptionsId() === 'rings'"
          [src]="'assets/images/binding/rings/' + option.value.id + '.png'"
          [ngClass]="additionalClasses['general-selected'] ? 'image-option-1' : 'image-option-2'"
        />
        <app-cover-thumbnail
          *ngIf="getOptionsId() === 'covers'"
          [id]="option.value.id"
          [color]="option.value.color"
          [ngClass]="additionalClasses['general-selected'] ? 'image-option-1' : 'image-option-2'"
        >
        </app-cover-thumbnail>
      </div>
    </div>

    <!-- Opciones por categoría -->
    <div *ngFor="let category of groupedOptions.groupedByCategory | keyvalue: originalOrder; let iCat = index">
      <!-- Título de la categoría -->
      <h3 class="categoryTitle">{{ getCategoryText(category.key) }}</h3>

      <!-- Opciones dentro de la categoría -->
      <div class="flex flex-row flex-wrap gap-1.5">
        <div
          (click)="
            onSelectOption(
              getGlobalIndex(option.value.id),
              isSoldOut(option, settings[settingOption].selected === getGlobalIndex(option.value.id) + 1)
            )
          "
          #tooltip2="tooltip"
          class="selection zoom flex items-center gap-2"
          *ngFor="let option of category.value; let i = index"
          [tooltip]="
            utils.getColorName(option.value.name) +
            (isSoldOut(option, settings[settingOption].selected === getGlobalIndex(option.value.id) + 1)
              ? ' (No disponible)'
              : '')
          "
          [tooltipClass]="
            isSoldOut(option, settings[settingOption].selected === getGlobalIndex(option.value.id) + 1)
              ? 'red-tooltip'
              : ''
          "
          [ngClass]="{
            selected: settings[settingOption].selected === getGlobalIndex(option.value.id) + 1,
          }"
        >
          <div class="image-container">
            <img
              *ngIf="getOptionsId() === 'rings'"
              [src]="'assets/images/binding/rings/' + option.value.id + '.png'"
              [ngClass]="additionalClasses['general-selected'] ? 'image-option-1' : 'image-option-2'"
            />
            <app-cover-thumbnail
              *ngIf="getOptionsId() === 'covers'"
              [id]="option.value.id"
              [color]="option.value.color"
              [ngClass]="additionalClasses['general-selected'] ? 'image-option-1' : 'image-option-2'"
            >
            </app-cover-thumbnail>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- OPCIONES DEL PLASTIFICADO -->
<app-lamination-options
  *ngIf="settingOption === 'laminationOptions'"
  [settings]="settings"
  [file]="file"
  [isModal]="isModal"
  (finalValues)="getLaminationOptions($event)"
  [styleType]="additionalClasses['general-selected'] ? 'default' : 'new'"
></app-lamination-options>
